'use client';

import Link from "next/link"
import { usePathname } from "next/navigation";
import TheoromLogo from "@/app/logo";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuIndicator,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu"
import { Briefcase, User } from "lucide-react";
import { useEffect, useState } from "react";


export default function SiteNav() {
  const pathname = usePathname();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, [pathname]);
  
  return (
    <header className="absolute md:top-6 z-50 w-full">
      <div className="m-auto flex md:w-2xl lg:w-5xl h-20 md:h-16 px-4 md:px-8 items-center justify-between">
        <Link href="/" className="cursor-pointer">
          <TheoromLogo className="h-5" />
        </Link>
        <NavigationMenu delayDuration={0}>
          { isMounted && !pathname.startsWith("/login") && !pathname.startsWith("/signup")
            && <MenuItems />
          }
        </NavigationMenu>
      </div>
    </header>
  )

  function MenuItems() {
    return (
      isMounted && (
        <NavigationMenuList className="md:space-x-6">
            <NavigationMenuItem>
              <NavigationMenuTrigger>Candidates</NavigationMenuTrigger>
              <NavigationMenuContent>
                <ul className="w-[300px] gap-3 p-2">
                  <li><NavigationMenuLink href="/jobs" className="select-none rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                      <div className="flex items-center gap-3">
                        <Briefcase className="h-10 w-10 flex-shrink-0" />
                        <div>
                          <p className="text-sm font-medium">Job Board</p>
                          <p className="line-clamp-2 text-sm text-muted-foreground">Browse listed roles and apply</p>
                        </div>
                      </div>
                    </NavigationMenuLink>
                  </li>
                  <li><NavigationMenuLink href="/login/candidate"  className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                    <div className="flex items-center gap-3">
                      <User className="h-10 w-10 flex-shrink-0" />
                      <div>
                        <p className="text-sm font-medium">Log In</p>
                        <p className="line-clamp-2 text-sm text-muted-foreground">View and track your applications</p>
                      </div>
                    </div>
                  </NavigationMenuLink></li>
                </ul>
              </NavigationMenuContent>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <NavigationMenuLink href="/login/recruiter"
                className={`${navigationMenuTriggerStyle()} bg-neutral-800 hover:bg-neutral-700 text-white hover:text-white`}
              >
                  Recruiter Login
              </NavigationMenuLink>
            </NavigationMenuItem>
          <NavigationMenuIndicator />
        </NavigationMenuList>
      )
    )
  }
}

